<template>
  <div class="cites" :class="$mq">
    <div class="image">
      <img src="@/assets/images/allgemein/cite_sign.png" alt="" />
    </div>
    <BaseCitesFade class="" />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.cites {
  color: white;
  width: 100%;
  text-align: center;
  .image {
    margin-bottom: 5px;
  }
}
</style>
